module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Background</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n        <input id=\"backgroundColor\"  type=\"color\" value=\"")
    ; __append(escapeFn( backgroundColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" ")
    ; __append(escapeFn( transparentBackground ? 'disabled' : '' ))
    ; __append("/>\r\n        <input id=\"backgroundColorText\" name=\"backgroundColor\" maxlength=\"7\" type=\"text\" style=\"width: 65px;\" value=\"")
    ; __append(escapeFn( backgroundColor ))
    ; __append("\" ")
    ; __append(escapeFn( transparentBackground ? 'disabled' : '' ))
    ; __append("/>\r\n    </div>\r\n   \r\n    <div id=\"background-color2\" class=\"col-md-6\">\r\n        ")
    ;  if (showGradient){ 
    ; __append("\r\n            <input id=\"styleBGColor2\" type=\"color\" value=\"")
    ; __append(escapeFn( backgroundGradientColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"styleBGColor2Text\" name=\"styleBGColor2\" maxlength=\"7\" type=\"text\" style=\"width: 65px;\" value=\"")
    ; __append(escapeFn( backgroundGradientColor ))
    ; __append("\" />\r\n        ")
    ;  } else { 
    ; __append("\r\n            <input type=\"checkbox\" id=\"transparentBackground\" name=\"transparentBackground\" class=\"form-radio-group\" ")
    ; __append(escapeFn( transparentBackground ? 'checked' : '' ))
    ; __append("> \r\n            <label class=\"form-group-label\">Transparent</label>\r\n        ")
    ;  } 
    ; __append("\r\n    </div>\r\n</div>")
  }
  return __output;

}